import React, { useMemo } from 'react';

import ProtectedData, { isProtectedData, LockIcon } from 'pages/item/v2/components/ProtectedData';

import useStyles from './styles';

interface Props {
    cveId: string;
    references: {
        [id: string]: { bulletinFamily: string }[];
    };
}

const RelatedBox: React.FC<Props> = ({ references, cveId }) => {
    const { classes } = useStyles();

    const tags = useMemo(() => {
        return Object.values(references).reduce((acc, item) => {
            const { bulletinFamily } = item[0];
            acc[bulletinFamily] ||= 0;
            acc[bulletinFamily] += item.length;
            return acc;
        }, {});
    }, [references]);

    const hasProtectedData = useMemo(() => Object.keys(tags).some((value) => isProtectedData(value)), [tags]);

    return (
        <div className={classes.root}>
            <div className={classes.title}>
                {`Related for ${cveId}`}
                {hasProtectedData ? <LockIcon /> : null}
            </div>
            <div className={classes.tags}>
                {Object.entries(tags).map(([tag, count], index) => (
                    <ProtectedData data={tag} key={index}>
                        <a className={classes.tag} href={'#related'}>
                            <span>{tag}</span>
                            <span className={classes.tagValue}>{count}</span>
                        </a>
                    </ProtectedData>
                ))}
            </div>
        </div>
    );
};
export default RelatedBox;
